<!-- Banner -->
<template>
  <div class="banner"></div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
<style scoped lang="less">
// pc
@media (min-width: 768px) {
  .banner {
    width: auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% auto;
    background-image: url(~@/assets/images/visa/banner.png);

    &::before {
      content: '';
      display: block;
      padding-top: 23.47%;
    }
  }
}

// h5
@media (max-width: 767px) {
  .banner {
    background: url(~@/assets/images/visa/h5-banner.png) no-repeat center center / cover;
    height: 53.3333vw;
  }
}
</style>
